import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        "h-10 w-full px-3 rounded-[var(--radius-input)]",
        "bg-[rgba(255,255,255,0.04)] text-[var(--color-snow)] placeholder:text-[var(--color-slate-300)]",
        "shadow-hairline",
        "outline-none focus-visible:shadow-[0_0_0_1px_var(--color-slate-200)_inset]",
        "transition-shadow duration-200 ease-out",
        "text-[14px]",
        className,
      )}
      {...props}
    />
  );
});

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        className={cn(
          "block w-full px-3 py-2.5 rounded-[var(--radius-input)]",
          "bg-[rgba(255,255,255,0.04)] text-[var(--color-snow)] placeholder:text-[var(--color-slate-300)]",
          "shadow-hairline",
          "outline-none focus-visible:shadow-[0_0_0_1px_var(--color-slate-200)_inset]",
          "transition-shadow duration-200 ease-out",
          "font-mono text-[13px] leading-[1.55]",
          "resize-vertical min-h-[160px]",
          className,
        )}
        {...props}
      />
    );
  },
);
